import dompurify from "dompurify";
import * as React from "react";

export type PurifiedHtmlProps = {
  html: string;
  className?: string;
};

/**
 * This generic component is used to sanitize HTML content when using dangerouslySetInnerHTML.
 *
 * We may be calling `sanitize` earlier when data is still being process; however we're erring on always
 * calling this before invoking the dangerouslySetInnerHTML to prevent XSS and injecting malicious code
 */
export const PurifiedHtml = ({ html, className }: PurifiedHtmlProps) => {
  const sanitizedHtml = React.useMemo(() => {
    return dompurify.sanitize(html);
  }, [html]);

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: sanitizedHtml,
      }}
      className={className}
    />
  );
};
